/**
 * Konfigurasi Theme Ant Design - Booku v2
 *
 * File ini mengkonfigurasi tema Ant Design menggunakan
 * warna dari sistem warna terpusat (colors.ts)
 */

import type { ThemeConfig } from 'antd';
import { colors } from './colors';

export const antdTheme: ThemeConfig = {
  token: {
    // Primary
    colorPrimary: colors.primary,
    colorPrimaryHover: colors.primaryHover,
    colorPrimaryActive: colors.primaryDark,
    colorPrimaryBg: colors.primarySurface,

    // Success
    colorSuccess: colors.success,
    colorSuccessBg: colors.successSurface,

    // Warning
    colorWarning: colors.warning,
    colorWarningBg: colors.warningSurface,

    // Error
    colorError: colors.error,
    colorErrorBg: colors.errorSurface,

    // Info
    colorInfo: colors.info,
    colorInfoBg: colors.infoSurface,

    // Text
    colorText: colors.textPrimary,
    colorTextSecondary: colors.textSecondary,
    colorTextDisabled: colors.textDisabled,

    // Background
    colorBgContainer: colors.bgPrimary,
    colorBgLayout: colors.bgSecondary,

    // Border
    colorBorder: colors.border,
    colorBorderSecondary: colors.borderLight,

    // Other
    borderRadius: 6,
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  components: {
    Button: {
      primaryShadow: 'none',
    },
    Card: {
      boxShadowTertiary: '0 1px 2px rgba(0, 0, 0, 0.05)',
    },
  },
};
